import { createAction, props } from '@ngrx/store';

export const AddressProviderSearchRequest = createAction('[Address Provider] Request place search', props<{ search: string }>());

export const AddressProviderSearchSuccessRequest = createAction(
    '[Address Provider] Success request place search',
    props<{ search: string; payload: OLO.DTO.AddressSugestionsDto }>(),
);

export const AddressProviderSearchErrorRequest = createAction('[Address Provider] Error request place search', props<{ search: string; ex: any }>());

export const AddressProviderReverseGeocodeRequest = createAction('[Address Provider] Request reverse geocoder location', props<{ geolocation: OLO.DTO.GeolocationDto }>());

export const AddressProviderReverseGeocodeSuccessRequest = createAction(
    '[Address Provider] Success request reverse geocoder location',
    props<{ geolocation: OLO.DTO.GeolocationDto; payload: OLO.DTO.AddressSugestionsDto }>(),
);

export const AddressProviderReverseGeocodeErrorRequest = createAction(
    '[Address Provider] Error request reverse geocoder location',
    props<{ geolocation: OLO.DTO.GeolocationDto; ex: any }>(),
);
